export const deepClone = (obj) => {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Couldn\'t deepClone object.', obj);
    throw e;
  }
};
